module.exports = __webpack_public_path__ + "static/media/WILLPOWER_HIGH.d9ad52c6.md";